const CreateSection = ({ icon, title, subtitle, action, flush, children }) => (
  <section className="prc-card">
    {(title || action) && (
      <header className="prc-card-h">
        {icon && <span className="prc-card-ico">{icon}</span>}
        <div style={{ minWidth: 0 }}>
          {title && <h2>{title}</h2>}
          {subtitle && <p>{subtitle}</p>}
        </div>
        {action && <div className="prc-card-actions">{action}</div>}
      </header>
    )}
    <div className={`prc-card-b${flush ? " prc-flush" : ""}`}>{children}</div>
  </section>
)

export default CreateSection
